var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageType == "DETAILS" ? _c("top-title", {
    attrs: {
      themeColor: _vm.themeColor
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("条款须知")))])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "clause1" ? _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      style: "font-size:" + _vm.styleObj.fontSize + "px;color:" + _vm.styleObj.fontColor
    }, [_vm._v("《" + _vm._s(_vm.$t(item.name)) + "》")]), _c("a-icon", {
      staticStyle: {
        color: "#989898"
      },
      attrs: {
        type: "right"
      }
    })], 1);
  }), 0) : _vm._e(), _vm.styleObj.controlsComponentsMark == "clause2" ? _c("div", {
    staticClass: "listBox2"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      style: "font-size:" + _vm.styleObj.fontSize + "px;color:" + _vm.styleObj.fontColor
    }, [_vm._v("《" + _vm._s(_vm.$t(item.name)) + "》")]), _c("a-icon", {
      staticStyle: {
        color: "#989898"
      },
      attrs: {
        type: "right"
      }
    })], 1);
  }), 0) : _vm._e(), _vm.styleObj.controlsComponentsMark == "clause3" ? _c("div", {
    staticClass: "listBox3"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      style: "font-size:" + _vm.styleObj.fontSize + "px;color:" + _vm.styleObj.fontColor
    }, [_vm._v(" 《" + _vm._s(_vm.$t(item.name)) + "》 ")]);
  }), 0) : _vm._e(), _c("div", [_vm._t("edit")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };